import styles from './TargitDashboardItem.module.scss';
import classNames from 'classnames';
import { Button } from 'ui/components';
import { useState, useEffect, useRef} from 'react';
import { ReactComponent as IconExitFull } from 'ui/icons/icon_exit_fullscreen.svg';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';

export interface TargitDashboardItemProps{
    dashboardTitle: string,
    dashboardUrl: string,
    onReady?: () => void;
    onFullScreen?: (fullScreen: boolean) => void;
    isFullScreen?: boolean;
}

export const TargitDashboardItem: React.FC<TargitDashboardItemProps> = ({dashboardTitle, dashboardUrl, onReady, onFullScreen, isFullScreen = false
}) => {
    const dictionary = useDictionaryContext();
    const [dashboardLoaded, setDashboardLoaded] = useState(false);
    const [isReady, setIsReady] = useState(false);
    const [showError, setShowError] = useState(false);
    const [aspectRatioValue, setAspectRatioValue] = useState('3 / 2');
    const timeoutRef = useRef(null);
    useEffect(() => {
        try {
            const url = new URL(dashboardUrl);
            const hostname = url.hostname;
			const protocol = url.protocol;

            if ((hostname === 'test-sjaellandsportalen.regionsjaelland.dk' || hostname === 'sjaellandsportalen.regionsjaelland.dk') && protocol === "https:") {
				setShowError(false);

                timeoutRef.current = setTimeout(() => {
                    onReady?.();
                    setDashboardLoaded(true);
				}, 5000);

                return () => {
                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                        timeoutRef.current = null;
                    }
				};

            } else {
                setDashboardLoaded(true);
                setShowError(true);
            }
        } catch (error) {
            setDashboardLoaded(true);
            setShowError(true);
        }
    }, [dashboardUrl]);

    useEffect(() => {
        if (dashboardLoaded) {
			setIsReady(true);

            if (typeof navigator !== 'undefined' && navigator.userAgent){
                const userAgent = navigator?.userAgent?.toLowerCase() || '';
				const isMobile = /Mobi|Android/i.test(userAgent);

                if (isMobile) setAspectRatioValue('4 / 16');
                else setAspectRatioValue('3 / 2');
			}

            onReady?.();
        }
    }, [dashboardLoaded, onReady]);

	return (
		<>
			<div className={classNames(styles.container, { [styles.fullScreenContainer]: isFullScreen })}>
				{!showError && (
                    <iframe
                        className={classNames(styles.desktopFrame, { [styles.loadingFrame]: !isReady })}
                        style={{ aspectRatio: aspectRatioValue }}
                        src={dashboardUrl}
                        title={dashboardTitle}
                        onLoad={() => {
                            setDashboardLoaded(true);
                            if (timeoutRef.current) {
                                clearTimeout(timeoutRef.current);
                                timeoutRef.current = null;
                            }
                        }}
                    />
                )}
                {showError &&
                    <div className={classNames(styles.desktopFrame, styles.loadingFrame)}>
                        {dictionary.getValue('Targit.ErrorMessage', null, 'Invalid TARGIT Dashboard')}
                    </div>
                }
            </div>

            {isFullScreen &&
                <Button
                    title='Exit fullscreen button'
                    ariaLabel='Targit exit fullscreen button'
                    className={styles.fullscreen_buttons___exitVideoFullScreenButton}
                    style="primary"
                    onClick={() => onFullScreen?.(false)}
                >
                    <IconExitFull aria-hidden="true" />
                </Button>
            }
        </>
    );
}